/**
 * Entry point for the Shaku module.
 * 
 * |-- copyright and license --|
 * @package    Shaku
 * @file       shaku\lib\index.js
 * @author     Ronen Ness (ronenness@gmail.com | http://ronenness.com)
 * @copyright  (c) 2021 Ronen Ness
 * @license    MIT
 * |-- end copyright and license --|
 * 
 */
'use strict';
module.exports = require('./shaku');